import { Injectable } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { UrlHelperService } from '@frontend/sports/navigation/core/feature/url-helper';

import { BreadcrumbModel } from '../../breadcrumbs/breadcrumb.models';
import { BreadcrumbsResolve } from '../../breadcrumbs/breadcrumbs.resolver';
import { CouponList } from '../../event-list-shared/coupons/coupon.model';

@Injectable()
export class CouponListBreadcrumbsResolver extends BreadcrumbsResolve<CouponList> {
    constructor(
        private sitecore: Sitecore,
        private urlHelper: UrlHelperService,
    ) {
        super();
    }

    protected customResolve(data: CouponList): BreadcrumbModel[] {
        if (!data || !data.sport) {
            return [];
        }

        const sport = data.sport;
        const title = this.sitecore.seo.SportBreadcrumbTitle.replace(/{{sport}}/, sport.name);

        return [
            this.createCrumb({
                icon: `sports-${sport.id}`,
                title,
                url: this.urlHelper.getSportUrl(sport),
            }),
        ];
    }
}
